<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_iii"></a><em>An Album of Union Soldiers and Their Stories</em></p>
<h1 class="h1" id="ch00_fm03">Faces of the Civil War</h1>
<p class="author">R<span class="small">ONALD</span> S. C<span class="small">ODDINGTON</span></p>
<p class="author">W<span class="small">ITH A</span> F<span class="small">OREWORD BY</span> M<span class="small">ICHAEL</span> F<span class="small">ELLMAN</span></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?000dbdee